/**
 * Session Enricher Middleware
 * Adds session-level metadata to events
 */

import type { Middleware, CollectedEvent } from '../types.js';

export interface SessionContext {
  sessionStartTime: number;
  pageViews: number;
  totalClicks: number;
  totalKeystrokes: number;
  maxScrollDepth: number;
}

export class SessionEnricher implements Middleware {
  name = 'session-enricher';
  private context: SessionContext;

  constructor(context: SessionContext) {
    this.context = context;
  }

  onPostCollect(event: CollectedEvent): CollectedEvent {
    const sessionDuration = Date.now() - this.context.sessionStartTime;

    return {
      ...event,
      // Add session-level metrics
      session_duration_ms: sessionDuration,
      session_page_views: this.context.pageViews,
      session_total_clicks: this.context.totalClicks,
      session_total_keystrokes: this.context.totalKeystrokes,
      session_max_scroll_depth: this.context.maxScrollDepth
    };
  }

  /**
   * Update session context
   */
  updateContext(updates: Partial<SessionContext>): void {
    this.context = { ...this.context, ...updates };
  }
}

